export const PRODUCT_HISTORY = 'productHistory';
export const PRODUCT_HISTORY_STORAGE_KEY = 'product-history';
export const PRODUCT_HISTORY_PREVIOUS_AUTH_STATUS =
  'product_history_previous_auth_status';
export const MAX_HISTORY_LENGTH = 20;
export const EXPIRATION_TIME_IN_MONTHS = 3;
export const RECENTLY_VIEWED_PRODUCTS_MIN_NUMBER = 4;
